var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.0100021C6.61305 0.0100021 4.32386 0.958215 2.63603 2.64604C0.948205 4.33387 0 6.62305 0 9.01C0 11.397 0.948205 13.6861 2.63603 15.374C4.32386 17.0618 6.61305 18.01 9 18.01C11.0373 18.0028 13.0105 17.2968 14.59 16.01L18.59 20.01H20V18.63L16 14.63C17.2969 13.0407 18.0036 11.0513 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0V0.0100021ZM9 16.01C7.61553 16.01 6.26215 15.5995 5.11101 14.8303C3.95986 14.0611 3.06265 12.9679 2.53284 11.6888C2.00302 10.4097 1.86441 9.00224 2.13451 7.64437C2.4046 6.2865 3.07128 5.03922 4.05025 4.06026C5.02921 3.08129 6.2765 2.4146 7.63437 2.14451C8.99224 1.87441 10.3997 2.01303 11.6788 2.54285C12.9579 3.07266 14.0511 3.96987 14.8203 5.12101C15.5895 6.27215 16 7.62553 16 9.01C16.0034 10.5972 15.4595 12.137 14.46 13.37C14.1425 13.7705 13.7763 14.1299 13.37 14.44C12.1344 15.4453 10.5929 15.9991 9 16.01Z",
    fill: "#2C3131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.04338f7d73d507240935a37a569548f9.svg";
export { ForwardRef as ReactComponent };